export default __webpack_public_path__ + "static/media/16-460x460.a72ce342.jpeg";